import { Injectable } from "@angular/core";
import { RegisterationUserViewModel } from "../../shared/models/registration.model";
import { RegistrationService } from "../registration/registration.service";
import { environment } from "../../../../environments/environment";
import { LoginStatus } from "../../shared/contentTypes";
import { CircularInjectionHelper } from "../../services/circularInjectionHelper";

@Injectable({
  providedIn: "root"
})
export class LoginActivationService {

  constructor(private _registrationService: RegistrationService,
    private _circularInjectionHelper: CircularInjectionHelper) { }

  // Does it need to return a Promise?
  public ResendActivationRequest(userName: string): Promise<void> {
    const me = this;
    return new Promise<void>(async (resolve) => {
      const result = await me._circularInjectionHelper.yourAppServer.Api.RetryVeryfication(userName);
      if (!result) {
        me._circularInjectionHelper.coreLogService.error("ForgetPasswordService.SendForgetPasswordRequest", "cant retry veryfication");
      }
      return resolve();
    });
  }

  /**
   * check if user activate his username by Email after Registration
   * @param registerationUserViewModel includes username and password
   */
  public CheckUserActivation(registerationUserViewModel: RegisterationUserViewModel): Promise<boolean> {
    const me = this;
    return new Promise<boolean>((resolve, reject) => {
      me._registrationService.LoginUser(registerationUserViewModel)
        .then((status) => {
          switch (status) {
            case LoginStatus.LogedIn:
            case LoginStatus.IncompleteRegistration:
              resolve(true);
              break;
            case LoginStatus.NotVerified:
              resolve(false);
              break;
            case LoginStatus.WrongUserOrPassword:
              reject();
              break;
            default:
              me._circularInjectionHelper.coreLogService.error("LoginActivationService.CheckUserActivation", "_registrationService.LoginUser unknown status", status);
              reject();
              break;
          }
        })
        .catch((error) => {
          me._circularInjectionHelper.coreLogService.error("LoginActivationService.CheckUserActivation", "_registrationService.LoginUser", error);
          reject();
        });
    });
  }
}
